"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var session = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var type, requestId, oxygenId, Authorization, sessionLambdaUrl, payload, headers, res;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            type = _ref.type, requestId = _ref.requestId, oxygenId = _ref.oxygenId, Authorization = _ref.Authorization, sessionLambdaUrl = _ref.sessionLambdaUrl;
            // Initilize payload and header
            payload = {
              type: type
            };
            headers = {
              'Content-Type': 'application/json'
            }; // Modify payload and header according to request type

            if (type === 'generateSignature') {
              payload = _objectSpread({}, payload);
              if (requestId != null) headers = _objectSpread(_objectSpread({}, headers), {}, {
                Session: requestId
              });
            } else if (type === 'signIn' || type === 'validateSignIn') {
              payload = _objectSpread(_objectSpread({}, payload), {}, {
                oxygenId: oxygenId
              });
              headers = _objectSpread(_objectSpread({}, headers), {}, {
                Session: requestId,
                Authorization: Authorization
              });
            } else if (type === 'signOut') {
              headers = _objectSpread(_objectSpread({}, headers), {}, {
                Session: requestId
              });
            } // Call api


            _context.prev = 4;
            _context.next = 7;
            return _axios.default.post(sessionLambdaUrl, payload, {
              headers: headers
            });

          case 7:
            res = _context.sent;
            return _context.abrupt("return", res.data.data);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            console.error(_context.t0);
            throw _context.t0;

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));

  return function session(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = session;
exports.default = _default;